module.exports = __webpack_public_path__ + "static/item--chloe--f1@3x.be77af07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--chloe--f1@3x.png
// module id = 635
// module chunks = 126511778744290